import { render, staticRenderFns } from "./PublicClubNews.vue?vue&type=template&id=0e0a2461&scoped=true"
import script from "./PublicClubNews.vue?vue&type=script&lang=js"
export * from "./PublicClubNews.vue?vue&type=script&lang=js"
import style0 from "./PublicClubNews.vue?vue&type=style&index=0&id=0e0a2461&prod&lang=scss"
import style1 from "./PublicClubNews.vue?vue&type=style&index=1&id=0e0a2461&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0a2461",
  null
  
)

export default component.exports